'use strict';

angular.module('internal.applications')
    .directive('internalApplicationActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'applications/components/application-actions/application-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;